<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <form id="formDragDrop" ref="fileform">
          <span class="drop-files">Drop the files here!</span>
        </form>
      </v-flex>
      <v-flex xs12 sm8>
        <v-data-table
          :headers="tableHeaders"
          :items="files"
          class="evelation-1"
          :pagination.sync="pagination"
          hide-actions
          no-data-text="No Files"
          loading="false"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>
                <i
                  class="material-icons"
                  v-on:click="removeFile( props.index )"
                  style="cursor:pointer;"
                >delete</i>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//https://serversideup.net/drag-and-drop-file-uploads-with-vuejs-and-axios/
export default {
  data() {
    return {
      tableHeaders: [
        { text: "Filename(s)", value: "name", sortable: false },
        { text: "", value: "", sortable: false }
      ],
      pagination: {
        rowsPerPage: 25
      },
      dragAndDropCapable: false,
      files: []
    };
  },
  mounted() {
    // Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    // If drag and drop capable, then we continue to bind events to our elements.
    if (this.dragAndDropCapable) {
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop"
      ].forEach(
        function(evt) {
          /*
        For each event add an event listener that prevents the default action
        (opening the file in the browser) and stop the propagation of the event (so
        no other elements open the file in the browser)
      */
          this.$refs.fileform.addEventListener(
            evt,
            function(e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      // Add an event listener for drop to the form
      this.$refs.fileform.addEventListener(
        "drop",
        function(e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            if (
              !["pdf", "doc", "docx", "txt"].indexOf(
                e.dataTransfer.files[i].name
                  .split(".")
                  .pop()
                  .toLowerCase()
              )
            ) {
              this.files.push(e.dataTransfer.files[i]);
            }
          }
        }.bind(this)
      );
    }
  },
  watch: {
    files: {
      handler: function() {
        this.$emit("fileList", this.files);
      }
    }
  },
  methods: {
    determineDragAndDropCapable() {
      var div = document.createElement("div");

      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    reset() {
      this.files = [];
    }
  }
};
</script>

<style>
#formDragDrop {
  display: block;
  height: 200px;
  width: 200px;
  background: #ccc;
  margin: auto;
  text-align: center;
  line-height: 200px;
  border-radius: 4px;
}

table.v-table111 thead tr {
  height: 40px !important;
}
</style>